import ModuleMixin from "../ModuleMixin";
import SnapshotModule from "../../../Snapshot/SnapshotModule/SnapshotModule.vue";
import SnapshotIcon from "../../../Snapshot/SnapshotIcon/SnapshotIcon.vue";
import {
  cloneDeep,
} from "lodash-es";

// @vue/component
export default {
  name: "Objekttitel",
  components: {
    SnapshotModule,
    SnapshotIcon,
  },
  mixins: [
    ModuleMixin,
  ],
  computed: {
    optionsFormstepDetailLocal() {
      const OPTIONS = cloneDeep(this.optionsFormstepDetail);
      OPTIONS.list = [
        {
          id: "titel",
          type: "text",
          htmlId: `${ this.htmlRegelNummer }_objekttitel`,
          label: "_LBL_GR_OBJEKTTITEL_LABEL_",
          required: true,
          view: "v",
          editonly: true,
          translate: true,
          startupFocus: true,
        },
      ];
      return OPTIONS;
    },

    labelHeader() {
      if (this.modelParameter.frage_text) {
        return this.modelParameter.frage_text;
      }
      return "_LBL_GR_OBJEKTTITEL_HEADER_";
    },

    statusDiff() {
      if (!this.snapshotModule) {
        return;
      }
      return this.snapshotModule.titel !== this.model.titel;
    },
  },

};
